let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("lopBT"), load("jSJdx"), load("bVl1P")]).then(() => parcelRequire('hnY2b'));